import React from "react";
import { Container } from "react-bootstrap";
import "../../incidentes.css";
import useVideoModal from "./useVideoModal";
import VideoModal from "./VideoModal";
import useProgresoVideos from "./useProgresoVideos";
import ProgresoResumen from "./ProgresoResumen";
import videoBaseURL from "./videoBaseURL";

const HistoriaIA = () => {
  const { show, videoActivo, handleShow, handleClose } = useVideoModal();
  const { estaVisto, marcarVisto } = useProgresoVideos();

  // Estructura simplificada de los 4 videos
  const videos = [
    {
      nombre: "Video 1: El Nacimiento de una Idea (1940s-1956)",
      url: `${videoBaseURL}H1.mp4`,
      contenido: [
        "Los sueños filosóficos y mecánicos.",
        'Alan Turing y la pregunta: "¿Pueden pensar las máquinas?".',
        'El "bautizo" oficial: La Conferencia de Dartmouth.',
      ],
    },
    {
      nombre: "Video 2: La Montaña Rusa - Hype y los 'Inviernos' (1960s-1990s)",
      url: `${videoBaseURL}H2.mp4`,
      contenido: [
        'El optimismo inicial y la IA "Simbólica" (basada en reglas).',
        "El Primer Invierno de la IA: La realidad golpea y los fondos se cortan.",
        'El breve resurgir de los "Sistemas Expertos" y el Segundo Invierno.',
      ],
    },
    {
      nombre: "Video 3: El Renacimiento - Datos, Poder y ML (1990s-2012)",
      url: `${videoBaseURL}H3.mp4`,
      contenido: [
        "El ingrediente secreto: El Machine Learning (enfoque estadístico).",
        'El "Kaspárov" de la IA: Deep Blue vence al ajedrez.',
        'La tormenta perfecta: La llegada de Big Data, GPUs y el "momento AlexNet".',
      ],
    },
    {
      nombre: "Video 4: La Revolución Actual - La Era Generativa (2017-Hoy)",
      url: `${videoBaseURL}H4.mp4`,
      contenido: [
        "El gran salto: De predecir a crear.",
        '"Attention Is All You Need": El nacimiento de la arquitectura Transformer.',
        "La explosión de los LLMs (GPT, BERT) y la IA Generativa (DALL-E, Midjourney).",
      ],
    },
  ];

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Historia de la Inteligencia Artificial</h1>
        </div>

        <ProgresoResumen vistos={videos.filter((v) => estaVisto(v.url)).length} total={videos.length} />

        <div className="orgproc-grid-4col">
          {videos.map((video, idx) => (
            <div className="orgproc-card" key={video.nombre}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Video #{idx + 1}</div>
                {estaVisto(video.url) && <span className="orgproc-visto-badge">✓ Visto</span>}
                <div className="orgproc-card-title">{video.nombre}</div>
                <ul className="orgproc-card-list" style={{ marginBottom: 16 }}>
                  {video.contenido.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
                <div className="orgproc-card-actions">
                  <button
                    type="button"
                    className="orgproc-card-btn"
                    onClick={() => handleShow(video)}
                  >
                    {estaVisto(video.url) ? "Volver a ver →" : "Reproducir Video →"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>

      <VideoModal show={show} video={videoActivo} onHide={handleClose} onPlay={marcarVisto} />
    </>
  );
};

export default HistoriaIA;